import React, { useState } from 'react';
import {
    Card,
    CardContent,
    CardHeader,
    CardMedia,
    Container,
    ToggleButton,
    ToggleButtonGroup,
    Typography
} from "@mui/material";
import styles from "./Warscroll.module.scss";
import {Casino} from "@mui/icons-material";
import EffectiveHealth from "./EffectiveHealth";
import Weapons from "./Weapons";
import Abilities from "./Abilities";
import {replaceNewLines} from "./Warscrolls";
import Warscroll from "./Warscroll";
import {v4 as uuidv4} from 'uuid';

const UpdateableScroll = ({scroll}) => {
    const modifiers = {reinforce:0,hitChange:0,woundChange:0,rendChange:0,math:false};
    return  <Container sx={{bgcolor: 'info.main', margin: "5px", borderRadius: 5, border: 1}} key={scroll.id}>
        <div className={styles.top}>
            {scroll.image ? <div className={styles.left + " " + styles.img}>
                <Card>
                    <CardMedia
                        component="img"
                        height={"300"}
                        image={scroll.image}
                        alt={scroll.name}
                    />
                </Card>
            </div> : null}
            <div className={styles.right}>
                <div className={styles.banner}>
                    <h1>{scroll.name}{scroll.isLegends ? " - Legend" : null}</h1>
                </div>

                <div className={styles.top}>
                    {scroll.move ? <Card sx={{margin: "5px"}}>
                        <CardContent>
                            <Typography variant="h4" align={"center"} component="div">
                                {scroll.move}
                            </Typography>
                        </CardContent>
                        <CardHeader title={"Move"}/>
                    </Card> : null}
                    {scroll.health ?
                        <Card sx={{margin: "5px"}}>
                            <CardContent> <Typography variant="h4" align={"center"}
                                                      component="div">{scroll.health}</Typography></CardContent>
                            <CardHeader title="Health"/>
                        </Card> : null}
                    {scroll.save ? <Card sx={{margin: "5px"}}>
                        <CardContent> <Typography variant="h4" align={"center"}
                                                  component="div">{scroll.save}</Typography></CardContent>
                        <CardHeader title="Save"/>
                    </Card> : null}
                    {scroll.ward ? <Card sx={{margin: "5px"}}>
                        <CardContent> <Typography variant="h4" align={"center"}
                                                  component="div">{scroll.ward}</Typography></CardContent>
                        <CardHeader title="Ward"/>
                    </Card> : null}
                    {scroll.wizardLevel ?
                        <Card sx={{margin: "5px"}}>
                            <CardContent> <Typography variant="h4" align={"center"}
                                                      component="div">{scroll.wizardLevel}</Typography></CardContent>
                            <CardHeader title="Wizard"/>
                        </Card> : null}
                    {scroll.priestLevel ?
                        <Card sx={{margin: "5px"}}>
                            <CardContent> <Typography variant="h4" align={"center"}
                                                      component="div">{scroll.priestLevel}</Typography></CardContent>
                            <CardHeader title="Priest"/>
                        </Card> : null}
                    {scroll.control ?
                        <Card sx={{margin: "5px"}}>
                            <CardContent> <Typography variant="h4" align={"center"}
                                                      component="div">{scroll.control}</Typography></CardContent>
                            <CardHeader title={scroll.keywords.includes("Manifestation") ? "Banishment" : "Control"}/>
                        </Card> : null}
                </div>
                <div className={styles.right + " " + styles.weapons}>
                    <Weapons weapons={scroll.weapons.filter(weapon => weapon.type === "ranged")}
                             keywords={scroll.keywords}
                             squadSize={scroll.modelCount}
                             modifications={modifiers}
                             type={"Ranged Weapons"}/>
                    <Weapons weapons={scroll.weapons.filter(weapon => weapon.type === "melee")}
                             keywords={scroll.keywords}
                             squadSize={scroll.modelCount}
                             modifications={modifiers}
                             type={"Melee Weapons"}/>
                </div>
            </div>
        </div>

        <div className={styles.main}>
            <Abilities abilities={scroll.abilities} wargear={
                scroll.wargearOptionsText ? <Card className={styles.wargear}>
                    <CardHeader title={"Wargear"}/>
                    <CardContent>{replaceNewLines(scroll.wargearOptionsText)}</CardContent>
                </Card> : null}/>

            <div>
                {scroll.keywords.length > 0 ?
                    <Container sx={{borderColor: 'secondary.main', border: 1}}>
                        <div><strong>KEYWORDS </strong></div>
                        <div className={styles.words}> {scroll.keywords.join(", ")}</div>
                    </Container> : null}
                <div>
                    {scroll.points ? <div>Points: {scroll.points}</div> : null}
                    {scroll.modelCount ?
                        <div>Model Count: {scroll.modelCount}</div> : null}
                    {scroll.baseSize ? <div>Basesize : {scroll.baseSize}</div> : null}
                    {scroll.notes ? <div>Notes: {scroll.notes}</div> : null}
                </div>
            </div>
        </div>

    </Container>
}

const defaultScroll = ()=>( {
    id: uuidv4(),
    name: 'Bloodwrack Viper',
    faction: ['Chorf'],
    points: null,
    modelCount: 1,
    move: '9"',
    save: '4+',
    ward: '6+',
    control: '4',
    health: '10',
    baseSize: '100mm',
    notes: null,
    isLegends: false,
    wargearOptionsText: null,
    weapons: [{
        id: uuidv4(),
        name: 'Fanged Strikes',
        type: 'melee',
        range: null,
        attacks: '3',
        hit: '4+',
        wound: '2+',
        rend: '1',
        damage: '3',
        abilities: ['Crit (Mortal)', 'Anti-HERO (+1 Rend)']
    }],
    abilities: [{
        name: 'Crushing Coils',
        phase: 'combatPhase',
        phaseDetails: 'Once Per Turn (Army), Any Combat Phase',
        castingValue: null,
        cpCost: null,
        declare: 'Pick an enemy **INFANTRY HERO** in combat with this **MANIFESTATION** to be the target.',
        effect: 'Roll a dice. On a 3+, the target has **STRIKE-LAST** for the rest of the turn.',
        keywords: ['Rampage']
    }],
    keywords: ['Monster', 'Manifestation', 'Endless Spell', 'Ward (6+)', 'Order', 'Daughters of Khaine']
})

const ScrollInput=()=> {
    const [warscrolls, setWarscrolls] = useState([]);
    const [currentWarscroll, setCurrentWarscroll] = useState(defaultScroll());

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCurrentWarscroll({
            ...currentWarscroll,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setWarscrolls([...warscrolls, currentWarscroll]);
        setCurrentWarscroll(defaultScroll());
    };

    return (
        <div style={{ display: 'flex', padding: '20px' }}>
            {/* Warscroll List Panel */}
            <div style={{ width: '33%', paddingRight: '10px' }}>
                <h2>Warscrolls</h2>
                {warscrolls.map((warscroll, index) => (
                    <UpdateableScroll scroll={warscroll}/>
                ))}
            </div>

            {/* Input Form Panel */}
            <div style={{ width: '33%', paddingRight: '10px' }}>
                <h2>Warscroll Editor</h2>
                <form onSubmit={handleSubmit}>
                    {/* Input fields - same as before */}
                    <div >
                        <label htmlFor="name">Name:</label>
                        <input type="text" id="name" name="name" value={currentWarscroll.name} onChange={handleChange} />
                    </div>
                    <div >
                        <label htmlFor="save">Save:</label>
                        <input type="text" id="save" name="save" value={currentWarscroll.save} onChange={handleChange} />
                    </div>
                    <div >
                        <label htmlFor="points">Points:</label>
                        <input type="number" id="points" name="points" value={currentWarscroll.points} onChange={handleChange} />
                    </div>
                    <button type="submit">Submit</button>
                </form>
            </div>

            {/* JSON Output Panel */}
            <div style={{ width: '33%' }}>
                <h2>Data</h2>
                <pre>{JSON.stringify(warscrolls, null, 2)}</pre>
            </div>
        </div>
    );
}

export default ScrollInput;
